import { IKeHoachThucTapDoanhNghiep } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapDoanhNghiep";
import { IKeHoachThucTapDoanhNghiepViewModel } from "../../../model/response/xet-thuc-tap/IKeHoachThucTapDoanhNghiepViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachThucTapDoanhNghiepActionsObj = {
    LOAD_BY_DOT_THUC_TAP_START: 0,
    LOAD_BY_DOT_THUC_TAP_SUCCESS: {} as IKeHoachThucTapDoanhNghiepViewModel[],
    LOAD_BY_DOT_THUC_TAP_ERROR: "",

    SAVE_START: {} as IKeHoachThucTapDoanhNghiep,
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0, // Assuming this is an ID for deletion
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    SHOW_EDIT_MODAL: undefined,
    CLOSE_EDIT_MODAL: undefined,
}

export const eKeHoachThucThucTapDoanhNghiepActionIds = generateActionTypeIds(eKeHoachThucTapDoanhNghiepActionsObj, "KE_HOACH_THUC_TAP_DOANH_NGHIEP");
export type IKeHoachThucTapDoanhNghiepActionTypes = IGenericActionType<typeof eKeHoachThucTapDoanhNghiepActionsObj, "KE_HOACH_THUC_TAP_DOANH_NGHIEP">;